/** The canvas addresses a device is pointed at, and the pairings that reach them. */

import { api } from "./api";

/** One paired device as the dashboard lists it. Hand-typed until the model reaches `sdk`. */
export interface PairingView {
  id: string;
  canvas_kind: string;
  label: string;
  created_at: string;
  last_seen_at: string | null;
  revoked_at: string | null;
}

export interface PairingProgress {
  status: string;
  approved_by: string | null;
  canvas_token: string | null;
}

export const canvases = {
  pairings: () => api.get<PairingView[]>("/v1/canvas/pairings"),
  approve: (userCode: string) =>
    api.post<PairingProgress>("/v1/canvas/pairings/approve", { user_code: userCode }),
  unpair: (pairingId: string) => api.delete<PairingView>(`/v1/canvas/pairings/${pairingId}`),
};
